import { fork, put, select, take, takeLatest } from 'redux-saga/effects';
import {
    API_GET_ACCOUNT_STATEMENT,
    API_GET_ACCOUNT_STATEMENT_SUCCESS,
    API_GET_ACCOUNT_STATEMENT_TO_DOWNLOAD
} from '../../api/lendingAPI/LendingAPI.actions';
import { createWorkersForPage } from '../pageStructure/routerWorkers/PageWorkerFactory.sagas';
import * as actions from './AccountHistory.actions';
import {
    getInitialDateTo,
    getInitialDateFrom
} from './AccountHistorySelectors';

export const accountHistorySagaWorkers = createWorkersForPage({
    page: 'ACCOUNT_HISTORY',
    isInPageLocation: (location) => location.pathname === '/history/',
    createPageFlowWorkers: () => [
        fork(accountHistoryDownloadWorker),
        fork(accountHistoryPageWorker)
    ]
});

function* accountHistoryDownloadWorker() {
    yield takeLatest(actions.ACCOUNT_HISTORY_DOWNLOAD, function* ({ payload }) {
        const dateFrom = yield select(getInitialDateFrom);

        yield put({
            type: API_GET_ACCOUNT_STATEMENT_TO_DOWNLOAD,
            dateFrom,
            dateTo: getInitialDateTo(),
            accountId: payload.accountId
        });
    });
}

function* accountHistoryPageWorker() {
    yield takeLatest(actions.ACTIVATE_ACCOUNT_HISTORY, function* () {
        yield put({ type: actions.ACCOUNT_HISTORY_DATA_LOADING });

        const dateFrom = yield select(getInitialDateFrom);

        yield put({
            type: API_GET_ACCOUNT_STATEMENT,
            dateFrom,
            dateTo: getInitialDateTo()
        });
        yield take(API_GET_ACCOUNT_STATEMENT_SUCCESS);

        yield put({ type: actions.ACCOUNT_HISTORY_READY });
    });
}
